import { bunja } from 'bunja';
import { atom } from 'jotai';

import { marginsAtom } from './internal/fixed-topics/margin';
import { r230522SocketBunja } from './socket';

export type * from './internal/fixed-topics/margin';

export const marginsBunja = bunja(() => {
  bunja.use(r230522SocketBunja);

  const getMarginAtom = atom((get) => {
    const margins = get(marginsAtom) || {};
    return margins;
  });
  getMarginAtom.debugLabel = 'getMarginAtom';

  return {
    marginsAtom,
    getMarginAtom,
  };
});
marginsBunja.debugLabel = 'marginsBunja';
